import { render } from "./OrderProcessing.vue?vue&type=template&id=689fe807"
import script from "./OrderProcessing.vue?vue&type=script&lang=js"
export * from "./OrderProcessing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__